// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetStoreWarehousesApiParameter } from "@store/Framework/Services/StoreWarehouseService";
import MyWarehouseState from "@store/Framework/Store/Store/Data/MyWarehouse/MyWarehouseState";
import { StoreWarehouseModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: MyWarehouseState = {
    address1: "",
    address2: "",
    allowShip: false,
    allowPickup: false,
    attributeTypeId: "",
    attributeValueId: "",
    city: "",
    country: "",
    description: "",
    displayName: "",
    id: "",
    isDefault: false,
    name: "",
    phone: "",
    postalCode: "",
    state: "",
    properties: {},
    latitude: 0,
    longitude: 0,
    countryId: "",
};

const actions = {
    "Store/Data/StoreWarehouse/SetMyWarehouse": (
        draft: Draft<MyWarehouseState>,
        action: { parameter: SetStoreWarehousesApiParameter; warehouse: StoreWarehouseModel },
    ) => {
        draft.address1 = action.warehouse.address1;
        draft.address2 = action.warehouse.address2;
        draft.allowPickup = action.warehouse.allowPickup;
        draft.allowShip = action.warehouse.allowShip;
        draft.attributeTypeId = action.warehouse.attributeTypeId;
        draft.attributeValueId = action.warehouse.attributeValueId;
        draft.city = action.warehouse.city;
        draft.countryId = action.warehouse.countryId;
        draft.description = action.warehouse.description;
        draft.displayName = action.warehouse.displayName;
        draft.id = action.warehouse.id;
        draft.isDefault = action.warehouse.isDefault;
        draft.latitude = action.warehouse.latitude;
        draft.longitude = action.warehouse.longitude;
        draft.name = action.warehouse.name;
        draft.phone = action.warehouse.phone;
        draft.postalCode = action.warehouse.postalCode;
        draft.properties = action.warehouse.properties;
        draft.state = action.warehouse.state;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreMyWarehouseActions = Parameters<typeof reducer>[1];
export default reducer;
